<script setup lang="ts">
import { useI18n } from "vue-i18n";
import { computed } from "vue";

const { tm } = useI18n();

const instructions = computed(
  () => tm("calculators.tarot.daily-card.instruction") as unknown
);
</script>

<template>
  <div class="flex flex-col text-left text-brown md:px-10">
    <h4 class="font-semibold text-xl leading-[24px] mb-6">
      {{ instructions.first_title }}
    </h4>
    <p class="text-base font-normal leading-[20px] mb-6">
      {{ instructions.first_paragraph }}
    </p>
    <h6 class="font-medium text-base leading-100p mb-4">
      {{ instructions.second_title }}
    </h6>
    <ul class="list-disc pl-6 text-sm font-normal leading-[20px]">
      <li v-for="(item, i) in instructions.list" :key="i">
        {{ item }}
      </li>
    </ul>
  </div>
</template>
